import { InjectionToken, Provider } from '@angular/core';
import { DaDataResponse, UserCompany } from '@company/const';
import { ActionReducerMap } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import {
  ADD_COMPANY_ENTITY,
  CompanyState,
  REMOVE_COMPANY_ENTITY,
  SEARCH_COMPANY_ENTITY,
  USER_COMPANIES_ENTITY,
} from '../company-state';
import { saveCompanyReducer } from './save-company.reducer';
import { selectCompanyReducer } from './select-company.reducer';

export function getReducers(): ActionReducerMap<CompanyState> {
  return {
    userCompanies: StateUtils.loaderReducer<UserCompany[]>(USER_COMPANIES_ENTITY),
    search: StateUtils.loaderReducer<DaDataResponse[]>(SEARCH_COMPANY_ENTITY),
    add: StateUtils.loaderReducer<string>(ADD_COMPANY_ENTITY),
    remove: StateUtils.loaderReducer<string>(REMOVE_COMPANY_ENTITY),
    selected: selectCompanyReducer,
    saved: saveCompanyReducer,
  };
}

export const reducerToken: InjectionToken<ActionReducerMap<CompanyState>> = new InjectionToken<
  ActionReducerMap<CompanyState>
>('CompanyReducers');

export const reducerProvider: Provider = {
  provide: reducerToken,
  useFactory: getReducers,
};
